var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPremiumGuidedcareSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3368 13.324L18.9077 4.324C19.4551 2.40759 18.0161 0.5 16.023 0.5H6.54782C5.20831 0.5 4.03112 1.38802 3.6632 2.676L1.09233 11.676C0.544906 13.5924 1.98389 15.5 3.97695 15.5H13.4522C14.7917 15.5 15.9689 14.612 16.3368 13.324Z",
    fill: "#5096E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01629 10.9615C6.94819 11.314 7.09413 11.5 7.44439 11.5H8.07682C8.42709 11.5 8.65087 11.314 8.71897 10.9615L9.03032 9.33636H10.3341C10.7038 9.33636 11.0735 9.25804 11.4043 9.1014C12.3384 8.66084 13 7.66224 13 6.48741C13 5.67483 12.64 5.02867 11.9881 4.71538C11.6768 4.56853 11.307 4.5 10.8789 4.5H8.79681C8.44654 4.5 8.22276 4.68601 8.15466 5.03846L7.01629 10.9615ZM9.32221 7.86783L9.69193 5.96853H10.5481C11.0152 5.96853 11.2487 6.23287 11.2487 6.64406C11.2487 7.1042 11.0443 7.50559 10.7233 7.72098C10.5676 7.82867 10.3633 7.86783 10.1492 7.86783H9.32221Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumGuidedcareSmall);
export default __webpack_public_path__ + "static/media/premium-guidedcare-small.9c1867eef2a456e41e967855caa769ee.svg";
export { ForwardRef as ReactComponent };